<template>
  <i class="px-icon" :class="classes"></i>
</template>

<script>
const VARIANT_CLASSES = {
  regular: 'far',
  solid: 'fas',
  light: 'fal',
  duotone: 'fad',
};

export default {
  name: 'PxIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    solid: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: null,
      validator: value => Object.keys(VARIANT_CLASSES).includes(value),
    },
    inline: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
    color: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variantClass() {
      if (this.variant) {
        return VARIANT_CLASSES[this.variant];
      }
      return this.solid ? 'fas' : 'far';
    },
    classes() {
      return [
        `fa-${this.icon}`,
        this.size && `fa-${this.size}`,
        this.variantClass,
        this.inline && 'inline',
        this.color && 'icon-color',
      ];
    },
  },
};
</script>

<style lang="scss">
@import '@shared/styles/variables';

.px-icon {
  color: currentColor;

  &.icon-color {
    color: $polly-light-blue;
  }
}

.px-icon.inline {
  display: inline;
  color: currentColor;
}
</style>
